import {useEffect} from 'react'

const RawHtmlInjector = ({htmlString}: {htmlString: string}) => {
    useEffect(() => {
        const container = document.createElement('div')
        container.innerHTML = htmlString

        // Extract and append style tags
        const styles = container.querySelectorAll('style')
        styles.forEach((style) => {
            document.head.appendChild(style.cloneNode(true))
        })

        // Extract and append script tags
        const scripts = container.querySelectorAll('script')
        scripts.forEach((script) => {
            const newScript = document.createElement('script')
            if (script.src) {
                newScript.src = script.src
            } else {
                newScript.textContent = script.textContent
            }
            document.head.appendChild(newScript)
        })

        return () => {
            // Optional cleanup: you could store appended nodes and remove them here
        }
    }, [htmlString])

    return null // nothing rendered visually
}

export {RawHtmlInjector}
